module.exports = __webpack_public_path__ + "static/media/CHN.52f614ae.svg";